import { NavLink } from 'react-router-dom';
import { ElinkIcon } from '@/components/base/elink-icon.component';
import { FRONTEND_VERSION, useBackendVersion } from '@/api/version/version.hooks';
import { usePermissions } from '@/hooks/use-permissions';
import { PERMISSIONS } from '@/constants/permissions';
import { IfPermitted } from '@/modules/internal-v2/shared/if-permitted.component';
import { NAVIGATION } from '../config/navigation.config';
import { BASE } from '../config/routes';
import { AssistantButton } from '../assistant/assistant-button.component';
import { UserMenu } from './user-menu.component';

export function Topbar() {
  const { data: backend } = useBackendVersion();
  const version = backend?.version ?? FRONTEND_VERSION;
  const isDev = backend?.environment === 'development';
  const { has, hasAny } = usePermissions();
  const visibleNavigation = NAVIGATION.filter((item) =>
    Array.isArray(item.permission)
      ? hasAny(item.permission)
      : has(item.permission),
  );

  return (
    <header className="v2-topbar">
      {/* Brand logo returns to the root partner/user switcher. */}
      <NavLink to="/" className="v2-topbar-brand" end>
        <span style={{ height: 18, display: 'inline-flex' }}>
          <ElinkIcon color="white" />
        </span>
      </NavLink>
      <span className="v2-topbar-module">EOS</span>

      <nav className="v2-topbar-nav">
        {visibleNavigation.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === BASE}
          >
            {item.label}
          </NavLink>
        ))}
      </nav>

      <span className="v2-topbar-spacer" />

      <span className="v2-topbar-meta">
        {isDev && 'DEV · '}v{version}
      </span>

      <IfPermitted permission={PERMISSIONS.AI_ASSISTANT_VIEW}>
        <AssistantButton />
      </IfPermitted>

      <UserMenu />
    </header>
  );
}
